var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-option',{staticClass:"option-container",class:_vm.optsContainerClasses,attrs:{"value":_vm.value}},[_vm._v("\n\t"+_vm._s(_vm.label)+"\n\t"),(_vm.isSideLabel)?_c('span',{staticClass:"side-label",style:(_vm.sideLabelStyle)}):_vm._e(),(_vm.src)?_c('img',{attrs:{"src":_vm.src}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }